export default __webpack_public_path__ + "static/media/Icon.dac301db.jpg";